module.exports = __webpack_public_path__ + "static/media/AI_2.676f1913.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_2.png
// module id = 117
// module chunks = 0